import {
    OptionContainer,
    OptionHeadline,
    OptionIcon,
} from "./ServiceModal.styles";
import { ServiceModalOption } from "./ServiceModal.types";
import { Stack } from "@mui/material";

export function ServiceModalOptionsList({
    options,
}: {
    options: ServiceModalOption[];
}) {
    return (
        <Stack>
            {options.map((option, key) => {
                return (
                    <OptionContainer
                        key={key}
                        onClick={option.onOptionClickHandler}
                        disabled={option.isDisabled ?? false}
                        textColor={option.color}
                    >
                        <OptionIcon>{option.icon}</OptionIcon>
                        <OptionHeadline> {option.headline} </OptionHeadline>
                    </OptionContainer>
                );
            })}
        </Stack>
    );
}
